// --------------------------------------- //
export const ROUTE_LOGIN = `/`;
export const ROUTE_REGISTE_FIRST = `/registeFirst`;
export const ROUTE_REGISTE_SECOND = `/registeSecond/:userId`;
export const ROUTE_LOGIN_FORGET_PWD = `/forgetPwd`;
export const ROUTE_MAIN_INDEX = `/workspace/workbench`;

export const ROUTE_FORM_ADD = `/components/form-add`;
export const ROUTE_FORM_LIST = `/components/form-template`;
export const ROUTE_FORM_DETAIL = `/components/form/:formId`;
export const ROUTE_FORM_CREATE = `/components/form/:formId/create`;

export const ROUTE_MODEL_ADD = `/application/model-add/:appId/:appName/:modelType`;
export const ROUTE_MODEL_DETAIL = `/application/model-edit/:formId`;
export const ROUTE_CRONJOB_LIST = `/application/cronjob-config`;
export const ROUTE_CRONJOB_DETAIL = `/application/cronjob-add/:jobId`;

export const ROUTE_MODEL_LIST = `/application/model-config`;
export const ROUTE_MODEL_CREATE = `/application/model/:formId/create`;
export const ROUTE_WORKFLOW_MY_PROCESSES = `/process/myProcess/:processInstanceId`;
export const ROUTE_WORKFLOW_EDITOR = `/process/edit/:processDefinitionId/:processServiceId/:deploymentId`;
export const ROUTE_WORKFLOW_VIEWDETAIL = `/process/view/:processDefinitionId`;
export const ROUTE_WORKFLOW_VIEWHISTORYDETAIL = `/process/historyView/:processDefinitionId/:pModelId`;
export const ROUTE_WORKFLOW_DESIGN = `/process/design/:processId`;

export const ROUTE_PROCESS_MY_TASK = `/process/myTask`;
export const ROUTE_PROCESS_MY_PROCESS = `/process/myProcess/:processInstanceId`;
export const ROUTE_PROCESS_MY_PROCESS_STARTED_BY = `/process/myProcessStartedBy`;
export const ROUTE_PROCESS_MY_PROCESS_PARTICIPANT = `/process/myProcessParticipant`;
export const ROUTE_PROCESS_MY_PROCESS_TEMPLATE = `/process/template`;
export const ROUTE_PROCESS_MY_MESSAGE = `/message/unreadMessage`;

export const ROUTE_PROCESS_MY_APPROVAL = `/process/myApproval/:approvalInstanceId`;
/** 跳转新版我的任务,我负责的 */
export const ROUTE_PROCESS_MY_TASK_MY_ASSIGNEE = `/process/myTaskAssignee`;
/** 跳转新版我的任务,我参与的 */
export const ROUTE_PROCESS_MY_TASK_MY_PARTICIPANT = `/process/myTaskParticipant`;
/** 跳转新版审批流模板 */
export const ROUTE_MY_APPROVAL_TEMPLATE_FOR_APPLY = `/process/processTemplateApproval`;
/** 跳转新版我申请的审批页面 */
export const ROUTE_MY_APPROVAL_APPLIED = `/workspace/myApply`;
/** 跳转新版我审批的审批页面 */
export const ROUTE_MY_APPROVAL_APPROVE = `/process/myApprovalApprove`;

export const ROUTE_PROCESS_MY_WARN_MESSAGE = `/message/warnMessage`;
// activiti的流程编辑器页面
export const ROUTE_ACTIVITI_DETAIL = `/editor/#/processes/:processId`;
export const ROUTE_ACTIVITI_VIEW_DETAIL = `/editor/#/processes2/:processId`;
export const ROUTE_ACTIVITI_VIEW_DIAGRAM = `/editor/#/processes3/:processId`;
export const ROUTE_ACTIVITI_EDITOR = `/editor/#/editor/:processId`;
export const ROUTE_ACTIVITI_DIAGRAM = `/display/processDiagram.html?processInstanceId=:processInstanceId&version=${Date.now()}`;
export const ROUTE_ACTIVITI_HISTORY_DIAGRAM = `/display/processDiagram.html?historyProcessInstanceId=:processInstanceId&version=${Date.now()}`;
/** 流程缩略图url */
export const ROUTE_ACTIVITI_PROCESS_THUMBNAIL = `/app/rest/models/:processId/thumbnail`;

export const ROUTE_USER_LIST = `/user/list`;
export const ROUTE_USER_ADD = `/user/add`;
export const ROUTE_USER_DETAIL = `/user/:userId`;

/** 添加員工,指向router/modules/route-system.js中的路徑 */
export const ROUTE_SYSTEM_EMPLOYEE_ADD = `/system/employee-add`;
export const ROUTE_EMPLOYEE_LIST = `/system/employee`;
/** 添加部门,指向router/modules/route-system.js中的路徑 */
export const ROUTE_SYSTEM_DEPARTMENT_ADD = `/system/department-add/:pId/:pName`;
export const ROUTE_SYSTEM_DEPARTMENT_LIST = `/system/department`;
/** 添加公司,指向router/modules/route-system.js中的路徑 */
export const ROUTE_SYSTEM_COMPANY_ADD = `/system/company-add`;
/** 添加职务,指向router/modules/route-system.js中的路徑 */
export const ROUTE_SYSTEM_POSITION_ADD = `/system/position-add/:pId/:pName`;
export const ROUTE_SYSTEM_POSITION_LIST = `/system/position`;
/** 添加资源,指向router/modules/route-system.js中的路徑 */
export const ROUTE_SYSTEM_RESOURCE_ADD = `/system/resource-add/:pId/:pName`;
export const ROUTE_SYSTEM_RESOURCE_LIST = `/system/resource`;
/** 添加角色,指向router/modules/route-system.js中的路徑 */
export const ROUTE_SYSTEM_ROLE_ADD = `/system/role-add`;
export const ROUTE_SYSTEM_ROLE_LIST = `/system/role`;

/** 添加运营BI视图 ,指向router/modules/route-operation.js中的路徑 */
export const ROUTE_OPERATION_PROCESSSTATE = `/operation/processState`;
export const ROUTE_OPERATION_USERREALTIMESTATE = `/operation/userRealtimeState`;
export const ROUTE_OPERATION_USERDETAILSTATE = `/operation/userDetailState`;
export const ROUTE_OPERATION_PROCESSMONITOR = `/operation/processMonitor`;
export const ROUTE_OPERATION_PROCESSTIMEGANTT = `/operation/timeGantt`;
export const ROUTE_OPERATION_CLOSEDLOOP = `/operation/closedLoop`;
export const ROUTE_OPERATION_APPROVALSTATE = `/operation/approvalState`;
export const ROUTE_OPERATION_APPROVALTIMERATIO = `/operation/approvalTimeRatio`;
export const ROUTE_OPERATION_PROCESSTIMEGANTT_PLANTIME = `/operation/planTimeGantt/:processInstanceId`;

/** 添加业务路由 ,指向router/modules/route-business.js中的路徑 */
export const ROUTE_BUSINESS_MODELLIST = `/business/business-center/:appId/:modelId`;
/** 添加应用路由 ,指向router/modules/route-application.js中的路徑 */
export const ROUTE_APPLICAION_MODELLIST = `/application/model-config`;
/** *创建新应用 */
export const ROUTE_APPLICAION_CREATE = `/application/application-tree`;
/** *管理应用 */
export const ROUTE_APPLICAION_CONFIG = `/application/application-config/:appId/:appName/:modelId`;

// 个人设置
// 修改密码
export const ROUTE_MYSETTING_UPDPWD = `/mySetting/updPwd`;
// 修改首页
export const ROUTE_MYSETTING_UPDFIRSTPAGE = `/mySetting/updFirstPage`;
// 基本信息设置
export const ROUTE_MYSETTING_BASEINFOSETTING = `/mySetting/baseInfoSetting`;

// 消息
export const ROUTE_MESSAGE = `/message/message/:messageId`;

export const ROUTE_CUSTOMER_MESSAGE_TEMPLATE_ADD = `/customer/customer-messageTemplate-add`;

// 应用商店
export const ROUTE_APPSTORE_LIST = `/workspace/appstore`;
export const ROUTE_APPSTORE_APP_VIEW = `/workspace/appstore/appView/:appId/:flag`;
export const ROUTE_APPSTORE_MODEL_VIEW = `/workspace/appstore/modelView/:formId/:appId`;
export const ROUTE_APPSTORE_COMPONENTS_VIEW = `/workspace/appstore/componentsView/:appId`;
export const ROUTE_APPSTORE_APP_DATA_VIEW = `/workspace/appstore/appDataView/:appId`;
export const ROUTE_APPSTORE_APP_INTRO_VIEW = `/workspace/appstore/appIntroView/:appId/:appName`;

// 系统帮助
export const ROUTE_SYSTEM_HELP = `/workspace/help`;

// 档案预览模式1
export const ROUTE_DOCUMENT_ARCHIVE_NAV = `/document/archive/:processInstanceId`;
export const ROUTE_DOCUMENT_ARCHIVE_VIEW1 = `/document/archiveView1`;
export const ROUTE_DOCUMENT_ARCHIVE_VIEW2 = `/document/archiveView2`;

// 特殊操作权限授权
export const ROUTE_RESOURCE_AUTH_NAV = `/system/authority`;
export const ROUTE_ROLE_RESOURCE_AUTH = `/system/roleResourceAuth`;
export const ROUTE_SPECIAL_RESOURCE_AUTH = `/system/specialResAuth`;

export const ROUTE_DOCUMENT_PROCESS_FILE = `/document/processFiles`;

// 公告管理
export const ROUTE_APPLICAION_NOTICELIST = `/application/notice-list`;
export const ROUTE_APPLICAION_NOTICEEDIT = `/application/notice-edit/:id`;

// 新版界面
export const ROUTE_MAIN_NEW_INDEX = `/workspace/needWorkingTask`;// 主页
export const ROUTE_BUSINESS_SYSTEM = `/businessSystem`;// 应用中心



// WEBPACK FOOTER //
// ./src/common/constants/const-router.js